import React = require('react');
import ReactDOM = require('react-dom');
import { SharedCompUserList, IUserItem } from './SharedCompUserList';
import Ajax from '../../lib/Ajax';
import { Tools } from '../../lib/Tools';
import { IProfileCompData } from '../../../interfaces/layout/blocks/IUser';

interface ILastUploadedFamilyMemberProps {

}

interface ILastUploadedFamilyMemberState {
    items:Array<IUserItem>
}

class LastUploadedFamilyMember extends React.Component<ILastUploadedFamilyMemberProps, ILastUploadedFamilyMemberState>{

      constructor(props:ILastUploadedFamilyMemberProps){
        super(props);
        // set initial state
        this.state = this.getInitState();
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/user/getLastUploadedFamilyMembers', 'POST', {}, (data:IProfileCompData) => {
            var items:Array<IUserItem> = [];
            for (var key in data.live) {
                var item = data.live[key];
                items.push({
                    id: item.id,
                    name: item.name,
                    img: item.img,
                    affinity: Tools.dateFormat(item.birthDate),
                    link: '/profilok/' + item.id,
                    address: item.city
                });
            }

            this.setState({
                items : items
            });
        });
    }


    protected getInitState():any{
        return {
            items: []
        };
    }

    render() {
        return (
            <SharedCompUserList editMode={false} title="Legutóbb feltöltött családtagok" emptyText="" userList={ this.state.items} />
        );
    }
}
export class InitLastUploadedFamilyMember {
    constructor() {
        var div: HTMLDivElement = document.getElementById('last_uploaded_family_member') as HTMLDivElement;
        if (div !== null) {
           ReactDOM.render(<LastUploadedFamilyMember  />, div);
        }
    }
}





// WEBPACK FOOTER //
// ./components/event/LastUploadedFamilyMember.tsx